<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">商户交易记录</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="查询时间起：">
            <el-date-picker
              v-model="CreateTime_Start"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              default-time="00:00:00"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="至：">
            <el-date-picker
              v-model="CreateTime_End"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              default-time="23:59:59"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="订单编号">
            <el-input
              v-model="Order_Code"
              placeholder="请输入订单编号" clearable
            ></el-input>
          </el-form-item>
           <el-form-item label="商户" prop="CurrentBusinessCode">
              <el-select  filterable placeholder="请选择"  v-model="CurrentBusinessCode" :disabled="BusinessCodeDisabled" clearable>
                <el-option
                  v-for="item in Businesses"
                  :key="item.BusinessCode"
                  :label="item.BusinessName"
                  :value="item.BusinessCode">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="子商户" prop="ChildBusinessCode">
              <el-select  filterable placeholder="请选择"  v-model="ChildBusinessCode" :disabled="ChildBusinessCodeDisabled" clearable>
                <el-option
                  v-for="item in ChildBusinesses"
                  :key="item.ChildBusinessCode"
                  :label="item.ChildBusinessName"
                  :value="item.ChildBusinessCode">
                </el-option>
              </el-select>
          </el-form-item>
           <el-form-item label="交易状态" prop="Status">
              <el-select  filterable placeholder="请选择"  v-model="CurrentStatus" clearable>
                <el-option
                  v-for="item in Statuses"
                  :key="item.Status"
                  :label="item.StatusStr"
                  :value="item.Status">
                </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="right">
            <el-button @click="onQueryBalance">查询</el-button>
            <el-button @click="onExportBalance">导出</el-button>
            <el-button v-if="isPassed=='1'" @click="onSearchBalance">查看余额</el-button>
            <el-button v-if="isPassed=='1'"  @click="onOutPayment">提 现</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <!-- <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div> -->
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                prop="SubMerId"
                label="商户编号"
              ></el-table-column>
              <el-table-column
                prop="SubMerName"
                label="商户名称"
              ></el-table-column>
               <el-table-column
                prop="Extends1"
                label="子商户编号"
              ></el-table-column>
              <el-table-column
                prop="Extends2"
                label="子商户名称"
              ></el-table-column>
              <el-table-column
                prop="Account"
                label="收款账号"
              ></el-table-column>
              <el-table-column
                prop="AccountName"
                label="收款账户名称"
              ></el-table-column>
              <el-table-column prop="TrxAmount" label="交易金额" >
                <template slot-scope="scope">
                 {{scope.row.PaySign}}{{scope.row.TrxAmount}}
                </template>
              </el-table-column>
              <el-table-column prop="MainPaySeparate" label="主商户分账金额">
                <template slot-scope="scope">
                 {{scope.row.PaySign}}{{scope.row.MainPaySeparate}}
                </template>
              </el-table-column>
              <el-table-column prop="PaySeparate" label="二级商户分账金额">
                 <template slot-scope="scope">
                 {{scope.row.PaySign}}{{scope.row.PaySeparate}}
                </template>
              </el-table-column>
               <el-table-column
                prop="StatusStr"
                label="交易状态"
              ></el-table-column>
              <!-- <el-table-column
                prop="DrawingFlag"
                label="是否关联订单"
              ></el-table-column> -->
              <el-table-column
                prop="OrderNo"
                label="订单编号"
              ></el-table-column>
              <el-table-column
                prop="CreateTime"
                label="时间"
              ></el-table-column>
              
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <BusinessBalanceInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :BusinessCode="CurrentBusinessCode"
        :AccountName="AccountName"
        :SubMerchantAccNo="SubMerchantAccNo"
        :RecBankNo="RecBankNo"
        :IsOutPay="IsOutPay"
      ></BusinessBalanceInfoPage>
    </ZjDialog>
  </div>
</template>

<script>
import WebApis from "../../../apis";
import utils from "../../../../../../utils";
import { showLoading, hideLoading } from "../../../../../../loading";
import BusinessBalanceInfoPage from "./BusinessBalanceInfo.vue";
import ZJApp from "../../../../../app";

export default {
  name: "BusinessBalancePage",
  controller: "UI",
  action: "BusinessBalance",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      CreateTime_Start: this.get_Day(0)+" 00:00:00",
      CreateTime_End: this.get_Day(0)+" 23:59:59",
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "商户交易记录",
        dialogFormVisible: false,
        width: "900px",
      },
      multipleSelection: [],
      IsOutPay: false,
      CurrentBusinessCode:"",
      AccountName:"",
      SubMerchantAccNo:"",
      RecBankNo:"",
      isPassed:"1",
      Businesses:[],
      BusinessCodeDisabled:false,
      ChildBusinesses:[],
      ChildBusinessCode:"",
      ChildBusinessCodeDisabled:false,
      Order_Code:"",
      CurrentStatus:0,
      Statuses:[
        {
          Status:0,
          StatusStr:"全部"
        },
        {
          Status:1,
          StatusStr:"已支付"
        },
        {
          Status:2,
          StatusStr:"已退款"
        },
        {
          Status:3,
          StatusStr:"退款失败"
        },
        {
          Status:4,
          StatusStr:"待支付"
        },
        {
          Status:5,
          StatusStr:"订单取消"
        },
        {
          Status:6,
          StatusStr:"提现中"
        },
        {
          Status:7,
          StatusStr:"提现成功"
        },
        {
          Status:8,
          StatusStr:"提现失败"
        }
      ],
    };
  },
  components: {
    BusinessBalanceInfoPage,
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
      let user = this.user;

      if(user.LoginName!="admin")
      {
        this.CurrentBusinessCode=user.LoginName;
        this.BusinessCodeDisabled=true;
      }
      else
      {
        this.CurrentBusinessCode=null;
        this.BusinessCodeDisabled=false;
      }

     return utils.waitAll([
       () => this.GetBusiness(),
       () => this.getBusinessByBusinessCode()]).then(()=>{
        this.init();
      });
    
  },
  mounted: function () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
  },
  computed: {},
  watch:{
    CurrentBusinessCode(val){
      this.ChildBusinessCode="";
      this.GetChildBusinesses(val);
    }
  },
  methods: {
    init() {
      return this.GetSubMerAccOutPaymentRecord();
    },
    GetBusiness(){
        return new WebApis.BusinessApi()
        .FindAll()
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.Businesses = r;
          this.InitChildBusiness();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户数据异常！" + e.RspMsg
              : "获取商户数据异常！",
            type: "error",
          });
        });
    },
     InitChildBusiness()
    {
      let user = this.user;

      if(user.LoginName!="admin")
      {
          this.BusinessCode= this.GetBusinessByUser(user);

          if(!this.BusinessCode)
          {
              this.GetChildBusinessByChildBusinessCode(user.LoginName);
          }
          else
          {
              this.GetChildBusinesses(this.BusinessCode);
              this.BusinessCodeDisabled=true;
          }
      }
      else
      {
        this.BusinessCode="";
        this.BusinessCodeDisabled=false;
      }
    },
    GetBusinessByUser(user)
    {
       var result="";
        this.Businesses.forEach(function(item){
            if(item.BusinessCode==user.LoginName)
            {
              result= user.LoginName;
              return;
            }
        });
        return result;
    },
    GetChildBusinessByChildBusinessCode(ChildBusinessCode)
    {
       let ChildBusinessSearch = {
        ChildBusinessCode:ChildBusinessCode
      };

      new WebApis.ChildBusinessApi()
        .GetItemByBusinessCodeAndChildBusinessCode(ChildBusinessSearch)
        .then((r) => {
          var result = r.data.Data;
          this.BusinessCode = result.BusinessCode;
          this.BusinessCodeDisabled=true;
          utils.waitAll([
                    () => this.GetChildBusinesses(this.BusinessCode)
                  ]).then(()=>{
                      this.ChildBusinessCode = result.ChildBusinessCode;
                      this.ChildBusinessCodeDisabled=true;
                  });
          
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    GetChildBusinesses(BusinessCode) {

      let ChildBusinessSearch = {
        BusinessCode:BusinessCode
      };

      return new WebApis.ChildBusinessApi()
        .FindByConditions(ChildBusinessSearch)
        .then((r) => {
          this.ChildBusinesses = r.data.Data;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取子商户数据异常！" + e.RspMsg
              : "获取子商户数据异常！",
            type: "error",
          });
        });
    },
    getBusinessByBusinessCode()
    {

      let BusinessSearch={
        BusinessCode: this.CurrentBusinessCode!=""?this.CurrentBusinessCode:null
      }

      return new WebApis.BusinessApi()
        .GetItemByBusinessCode(BusinessSearch)
        .then((res)=>{
            this.BusinessInfo = res.data.Data;
            this.AccountName=this.BusinessInfo.AccountName;
            this.SubMerchantAccNo=this.BusinessInfo.Account;
            this.RecBankNo=this.BusinessInfo.BankNo;
            this.isPassed=this.BusinessInfo.isPassed;

            if(this.BusinessInfo.IsMain=="1")
            {
              this.CurrentBusinessCode=null;
              this.BusinessCodeDisabled=false;

              this.Business_Code="";
              this.BusinessCodeDisabled=false;
            }
        });
    },
    GetSubMerAccOutPaymentRecord() {
      showLoading(".zj-table-container");


      let BusinessOrderSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        SubMerId: this.CurrentBusinessCode!=""?this.CurrentBusinessCode:null,
        Extends1:this.ChildBusinessCode!=""?this.ChildBusinessCode:null,
        Status:this.CurrentStatus!=0?this.CurrentStatus:null,
        OrderNo:this.Order_Code!=""?this.Order_Code:null,
        BeginDate: new Date(this.CreateTime_Start),
        EndDate: new Date(this.CreateTime_End),
        TotalCount: 0,
      };

      console.log(BusinessOrderSearch);
      return new WebApis.BusinessOutPaymentApi()
        .GetPageContentByConditions(BusinessOrderSearch)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          console.log("获取交易记录异常",e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户提现数据异常！" + e.RspMsg
              : "获取商户提现数据异常！",
            type: "error",
          });
          hideLoading();
        });
    }, // 点击查询按钮
    onSearch() {
      this.currentPage=1;
      this.GetSubMerAccOutPaymentRecord();
    },
    clearsearch() {
      this.Order_Code = "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSubMerAccOutPaymentRecord();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetSubMerAccOutPaymentRecord();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    formatDate(dateTime)
    {
      const date = new Date(dateTime);
      return (
        date.getFullYear() +
        "-" +
        (date.getMonth()+1) +
        "-" +
        date.getDate()
      );
    },
    onQueryBalance()
    {
      this.GetSubMerAccOutPaymentRecord();
    },
    onExportBalance()
    {
      showLoading(".zj-layout-container");

      let BusinessOrderSearch = {
        SubMerId: this.CurrentBusinessCode!=""?this.CurrentBusinessCode:null,
        Extends1:this.ChildBusinessCode!=""?this.ChildBusinessCode:null,
        Status:this.CurrentStatus!=0?this.CurrentStatus:null,
        OrderNo:this.Order_Code!=""?this.Order_Code:null,
        BeginDate: new Date(this.CreateTime_Start),
        EndDate: new Date(this.CreateTime_End),
      };

      return new WebApis.BusinessOutPaymentApi()
        .FindByConditionsToExcel(BusinessOrderSearch)
        .then((res)=>{
            if(res.data.RspCode=="1")
            {
               var results = res.data.Data;
               this.onDownLoad(results);
            }
            else
            {
               this.$message({
                  showClose: true,
                  message: res.data.RspMsg,
                  type: "error",
                });
            }
            hideLoading();
        }).catch((e) => {
          console.log("导出交易记录异常",e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "导出交易记录异常！" + e.RspMsg
              : "导出交易记录异常！",
            type: "error",
          });
          hideLoading();
        });
    },
    onDownLoad(results) {
      const tHeader = [
        "商户编号",
        "商户名称",
        "子商户编号",
        "子商户名称",
        "收款账号",
        "收款账户名称",
        "收款银行",
        "交易金额",
        "主账户分账金额",
        "二级账户分账金额",
        "交易状态",
        "订单编号",
        "商户订单号",
        "时间"
      ];

      var Exportlist = [];

      if(results.length>0)
      {
        results.forEach((item)=>{
          var obj=[];
          obj.push(item.SubMerId);
          obj.push(item.SubMerName);
          obj.push(item.Extends1);
          obj.push(item.Extends2);
          obj.push(item.Account);
          obj.push(item.AccountName);
          obj.push(item.RecBank);
          if(item.PaySign!=null && item.PaySign=="-")
          {
            item.TrxAmount=0-item.TrxAmount;
            item.MainPaySeparate=0-item.MainPaySeparate;
            item.PaySeparate=0-item.PaySeparate;
          }
          obj.push(item.TrxAmount);
          obj.push(item.MainPaySeparate);
          obj.push(item.PaySeparate);
          obj.push(this.GetStatusStr(item.Status));
          obj.push(item.OrderNo);
          obj.push(item.ThirdPayOrderNo);
          obj.push(item.CreateTime);

          Exportlist.push(obj);
        });
      }

       ZJApp.ZJUtils.Export2Excel.export_json_to_excel(
            tHeader,
            Exportlist,
            "商户管理" + this.get_Day(0)
          );

    },
    GetStatusStr(Status)
    {
        var StatusStr = "";
        switch (Status)
        {
            case 1: StatusStr = "已支付" ; break;
            case 2: StatusStr = "已退款"; break;
            case 3: StatusStr = "退款失败"; break;
            case 4: StatusStr = "待支付"; break;
            case 5: StatusStr = "订单取消"; break;
            case 6: StatusStr = "提现中"; break;
            case 7: StatusStr = "提现成功"; break;
            case 8: StatusStr = "提现失败" ; break;
        }
        return StatusStr;
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetSubMerAccOutPaymentRecord();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
    onSearchBalance()
    {
      this.IsOutPay = false;
      this.dilaogconfig.title = "商户余额";
      this.dilaogconfig.dialogFormVisible = true;
    },
    onOutPayment()
    {
      this.IsOutPay = true;
      this.dilaogconfig.title = "商户余额";
      this.dilaogconfig.dialogFormVisible = true;
    },
    get_Day(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      //let timevalue= new Date(tYear + "-" + tMonth + "-" + tDate);
      let timevalue = tYear + "-" + tMonth + "-" + tDate;
      return timevalue;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    }
  },
};
</script>
